<template>
    <v-card max-width="500" class="mx-auto" v-if="user">
        <v-card-actions>
            <v-btn text color="blue-grey" router :to="{ name: 'MyPage'}">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="ml-2">돌아가기</span>
            </v-btn>
        </v-card-actions>
        <v-img src="/farewell.jpg" class="white--text align-end">
            <v-card-title>가지마~~</v-card-title>
        </v-img>
        <v-list>
            <v-subheader>내 정보</v-subheader>
            <v-list-item>
                <v-list-item-avatar>
                    <v-img :src="user.avatar"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-text="user.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="user.alias"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                    <v-list-item-title v-text="user.total"></v-list-item-title>
                    <v-list-item-subtitle>
                        <span v-for="n in user.level" :key="n">
                            <v-icon small color="orange">mdi-star</v-icon>
                        </span> {{ user.level }}부
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-sheet
            v-if="(user.wins + user.loses) > 0"
            class="v-sheet--offset mx-auto"
            color="cyan"
            max-width="calc(100%)"
        >
            <v-sparkline
                :labels="user.history"
                :value="user.history"
                stroke-linecap="round"
                color="white"
                type="trend"
                line-width="2"
                padding="16"
                height="130"
                auto-draw
            ></v-sparkline>
        </v-sheet>
        <v-card flat v-if="(user.wins + user.loses) == 0" height="190" color="blue-grey lighten-4">
            <v-card-title class="justify-center blue-grey--text">No record!</v-card-title>
        </v-card>
        <v-card-text>
            데이터베이스에 있는 모든 기록이 지워집니다.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mb-3" dark color="blue-grey accent-4" @click="farewell">탈퇴하기</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>  
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    name: 'Farewell',
    data: () => ({
        user: null,
        openLeagueMembers: []
    }),
    methods: {
        farewell(){
            // delete the user from users collection
            db.collection('users').doc(this.user.id).delete().then(() => {
                console.log('user deleted from users collection')
            })

            // delete the user from the Open League members
            this.openLeagueMembers = this.openLeagueMembers.filter(member => {
                return member.alias != this.user.alias
            })
            db.collection('groups').doc('open-league').update({
                members: this.openLeagueMembers
            })
            
            // delete the user from the user's joinedGroups
            this.user.joinedGroups.forEach(group => {
                db.collection('groups').doc(group.id).get().then(snapshot => {
                    let group = snapshot.data()
                    let index = null
                    group.members.forEach((member, i) => {                            
                        if(member.alias == this.user.alias){
                            index = i;
                        }
                    })
                    group.members.splice(index, 1)
                    return group.members
                }).then(members => {
                    db.collection('groups').doc(group.id).update({
                        members: members
                    })
                })
            })

            // delet the user from Authentication
            firebase.auth().currentUser.delete().then(() => {
                // User deleted.
                console.log('User deleted from Authentication')
                this.$router.push({ name: 'Home' })
            }).catch(error => {
                // An error happened.
                console.log('An error happened.', error.message)
            });
        }
    },
    created() {
        let user = firebase.auth().currentUser;

        // get user
        if(user){
            db.collection('users').where('user_id', '==', user.uid).get().then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = {
                        ...doc.data(),
                        id: doc.id
                    }
                })
            }).then(() => {
                // get the members from Open League
                db.collection('groups').doc('open-league').get().then(snapshot => {
                    this.openLeagueMembers = snapshot.data().members
                })
            })
        }
    }
};
</script>